export type UseTagsIndexReturn = {
  /** This route always redirects server-side; hook exists for pattern consistency */
}

export function useTagsIndex(): UseTagsIndexReturn {
  return {}
}
